import React from "react";
import Basket from "features/basket/containers/Basket";
const BasketComponent = () => {
  return <Basket />;
};

export default BasketComponent;
